import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosStudentInstance from "../../axiosStudentInstance.js";

export const fetchStudentProfile = createAsyncThunk(
  "student/fetchProfile",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosStudentInstance.get("/student/profile");

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch profile"
      );
    }
  }
);

export const updateStudentProfile = createAsyncThunk(
  "student/updateProfile",
  async (formData, { rejectWithValue }) => {
    try {
      const data = new FormData();

      for (const key in formData) {
        if (formData[key] instanceof File) {
          data.append(key, formData[key]);
        } else if (Array.isArray(formData[key])) {
          data.append(key, JSON.stringify(formData[key]));
        } else {
          data.append(key, formData[key] ?? "");
        }
      }

      const response = await axiosStudentInstance.patch(
        "/student/update-profile",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data; // { message, student }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Student update failed"
      );
    }
  }
);
